import React from 'react';
import VerifyMemberPage from './components/VerifyMemberPage';
import useVerifyMemberController from './controllers/useVerifyMemberController';
import './input.css';

const VerifyMember = () => {
    const controller = useVerifyMemberController();

    return <VerifyMemberPage {...controller} />;
};

export default VerifyMember;
